import type { MarketExceptionType } from '../../MarketExceptionTypes'
import { Common } from '../Common/Common'

export const MA: MarketExceptionType = {
  ...Common,
  hasStoreCredit: true,
  signUpReCaptcha: true,
  showPasswordRequirements: true,
  signupPrivacyPolicy: {
    enabled: true,
    required: false,
  },
  checkoutTermsAndConditionsAgreementCheckbox: {
    enabled: true,
    required: true,
  },
  currencyCode: 'MAD',
  creditCardProvidersSupported: ['VI', 'MC', 'AX'],
  isPickupMarket: true,
  hasAddressRegion: true,
  supportsStoreCredit: true,
  hasCMI3DS: true,
  hasProductAvailability: true,
  tax: {
    inclusive: true,
    noFrontendTaxCalculation: true,
    explicitlyExclusive: false,
  },
  isHostedPayments: true,
  hasBankWire: true,
}
